import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='sm:text-right pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-4 border-[#cd853f]'>
                        Sobre
                    </p>
                </div>
                <div></div>
            </div>
            <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                <div className='sm:text-right text-4xl font-bold'>
                    <p>
                       Sou um profissional dedicado a minha carreira e sempre busco desenvolver minhas habilidades técnicas.
                    </p>
                </div>
                <div>
                    <p>
                       Durante minha trajetória já participei de projetos e grupos das mais variadas áreas, onde sempre consegui contribuir para otimizar entregas e aplicar meu conhecimento.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default About